export const PROTOCOL = "https";
export const SERVER_URL =
  "wpgjnetwork.azurewebsites.net";
export const CLIENT_URL = "localhost:3000";
export const BASE_URL = `${PROTOCOL}://${SERVER_URL}`;
export const API_URL = `${BASE_URL}/wp-json/wp/`;
export const SOCKET_URL = `wss://${SERVER_URL}`;
export const FILE_SERVER_URL = `${PROTOCOL}://${SERVER_URL}/public/`;
